(function(w, d) {
  try {
    if (
      localStorage.getItem('ac_verified') ||
      localStorage.getItem('ac_verified_uuid')
    ) {
      return;
    }
  } catch (e) {}

  const agecheckerElements = [
    '[name=checkout]',
    '[href="/checkout"]',
    '[data-href="/checkout"]',
    '.sezzle-checkout-button'
  ];

  const agecheckerLock = function(els) {
    if (!els) return;

    for (let i = 0; i < els.length; i++) {
      const el = els[i];

      if (!el) return;

      if (
        el.className.indexOf('agechecker') == -1 &&
        !el.getAttribute('disabled')
      ) {
        el.setAttribute('disabled', true);
      } else if (
        el.className.indexOf('agechecker') != -1 &&
        el.getAttribute('disabled')
      ) {
        el.removeAttribute('disabled');
      }
    }
  };

  setInterval(function() {
    for (let i = 0; i < agecheckerElements.length; i++) {
      agecheckerLock(
        document.querySelectorAll(agecheckerElements[i])
      );
    }
  }, 5);

})(window, document);